/**
 * Roster lookups.
 *
 * These lived in GameStateContext, which made it a module exporting both a
 * provider and plain functions — enough to cost the context file its fast-refresh
 * boundary. They are pure functions over a player list and belong on their own.
 */

import type { PlayerInfo } from "./protocol";

export const getPlayerName = (playerId: string, players: PlayerInfo[]): string => {
    return players.find(p => p.id === playerId)?.name || "Unknown";
};

/**
 * The room host's name, for the screens that sit blocked until they act.
 *
 * Falls back to "the host" rather than a bare "host" so the sentence still reads
 * if the roster hasn't arrived yet — but that is a fallback, not the label: every
 * one of these screens should be naming a person.
 */
export const getHostName = (players: PlayerInfo[]): string => {
    return players.find(p => p.isHost)?.name || "the host";
};
